import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M3.58 10.289h6.494V3.75h3.524v6.539h6.822l-8.431 9.961-8.409-9.961z"
}), 'LongArrowDown');